import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Typography } from '@mui/material';
import { useSingleUser, USER_LOADED_STATUS } from 'features/users';

export const UserName = ({
  userId,
  short = false,
  shortFirstName = false,
  TypographyProps = {},
}) => {
  const { user } = useSingleUser(userId, false, USER_LOADED_STATUS.BASIC);

  if (!userId) return null;
  if (!user || user.loading)
    return <Skeleton component={'span'} variant={'text'} />;

  return (
    <Typography
      component={'span'}
      variant="inherit"
      {...{
        ...TypographyProps,
        sx: {
          textTransform: 'capitalize',
          ...(TypographyProps?.sx ?? {}),
        },
      }}
    >
      {shortFirstName
        ? `${user?.firstName?.substring(0, 10)}`
        : user?.firstName}{' '}
      {short ? `${user?.lastName?.charAt(0)}.` : user?.lastName}
    </Typography>
  );
};

UserName.propTypes = {
  userId: PropTypes.string,
  short: PropTypes.bool,
  shortFirstName: PropTypes.bool,
  TypographyProps: PropTypes.object,
};
